import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ICategoryDto } from '@models/category-dto';
import { ClashFilter } from '@models/clash/clash-form.dto';
import { GroupKeyDto } from '@models/clash/group-key-dto';
import { ICompetitionBlockDto } from '@models/competition-block-dto';
import { ICompetitionDto } from '@models/competition-dto';
import { ICompetitionModelDto } from '@models/competition/step-paramaterization/dtos/competition-model-dto';
import { ICompleteStepParameterizationDto } from '@models/competition/step-paramaterization/dtos/complete-simple-step-parameterization-dto';
import { ISimpleStepParameterizationDto } from '@models/competition/step-paramaterization/dtos/simple-step-parametrization-dto';
import { CompetitionModelFilter } from '@models/competition/step-paramaterization/filters/competition-model-filter';
import { StepParametrizationFilter } from '@models/competition/step-paramaterization/filters/step-parametrization-filter';
import { ParameterizationPostForm } from '@models/competition/step-paramaterization/form/parameterization-post-form';
import { StepParameterizationSubscriptionForm } from '@models/competition/step-paramaterization/form/step-parametrization-subscription-form';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { ParameterizationStepTypeEnum } from '@models/enums/parameterization-step-type-enum';
import { AttachmentExtensionEnum } from '@models/enums/attachment-extension-enum';
import { IEventDto } from '@models/event-dto';
import { ListAthleteEnrollmentsDto } from '@models/list-athlete-enrollments-dto';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';
import { noWhitespaceValidator } from '@modules/competition/step-parameterization/step-parameterization-form/validators/no-whitespace.validator';
import { ChampionshipService } from '@shared/services/championship.service';
import { ClashService } from '@shared/services/clash.service';
import { CompetitionBlockService } from '@shared/services/competition-block.service';
import {
  RodadaDto,
  RodadaForm,
  RodadasService,
  TipoRodadaEnum,
} from '@shared/services/competition/rodadas.service';
import { SportParameterizationService } from '@shared/services/competition/sport-parameterization.service';
import { StepParameterizationService } from '@shared/services/competition/step-parametrization.service';
import {
  ConfirmationModalService,
  ConfirmationModalType,
} from '@shared/services/confirmation-modal.service';
import { EnrollmentAthleteService } from '@shared/services/enrollment-athlete.service';
import { EventService } from '@shared/services/event.service';
import { FilterKeyEnum } from '@shared/services/filter-service/filter-keys';
import { provideFilter } from '@shared/services/filter-service/filter.service';
import { LoadingService } from '@shared/services/loading.service';
import { AttachmentService } from '@shared/services/attachment.service';
import { ControlsOf } from '@shared/types/form-group-of';
import { BehaviorSubject, distinctUntilChanged, filter, startWith } from 'rxjs';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { enumToDropdownOptions } from 'src/app/core/utilities/utility-functions';
import { ChaveEmbateForm } from './../../../../models/competition/step-paramaterization/form/chave-embate-form';
import { FederationService } from '@shared/services/federation.service';
import { IListFederationDto } from '@models/list-federation-dto';
import { GenreCateroryEnum } from '@models/enums/genre-category-enum';

type TopSeedParticipant = ListAthleteEnrollmentsDto & {
  isCabecaChave?: boolean;
};
@Component({
  selector: 'sigecom-step-parameterization',
  templateUrl: './step-parameterization-form.component.html',
})
export class StepParameterizationComponentForm
  extends BaseComponent
  implements OnInit
{
  get rodadaForms(): FormArray<FormGroup<ControlsOf<RodadaForm>>> {
    return this.stepParameterizationForm.controls.rodadaForms as FormArray;
  }

  changePosition(index: number, way: 'up' | 'down'): void {
    const targetIndex = way === 'up' ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= this.rodadaForms.length) return;

    const current = this.rodadaForms.at(index);
    const target = this.rodadaForms.at(targetIndex);
    this.rodadaForms.setControl(targetIndex, current);
    this.rodadaForms.setControl(index, target);
  }

  selectedEntries: TopSeedParticipant[] = [];
  selectedEntriesOtherPhase: TopSeedParticipant[] = [];
  private autoSelectEnabled = false;
  petNrId?: number;
  eveNrId?: number;
  bloNrId?: number;
  comNrId?: number;
  catNrId?: number;
  espNrId?: number;
  qtdMaxParticipantsStepParametrization?: number;

  ettNrIdSportTemplateSaved?: number;

  isEditing: boolean = false;

  currentStep = 0;

  isKeysGenerated?: boolean = true;
  qtdChaves?: number;

  allowChange: boolean = false;
  isBlocked: boolean = false;
  petBlEmbDireto: boolean = false;

  private otherPhaseBindingsInit = false;
  isOtherStepValue: boolean = false;
  faseOptions?: IPage<ISimpleStepParameterizationDto>;
  clashOptions?: IPage<GroupKeyDto>;
  private readonly fasePage: PageRequest = { page: 0, size: 100 };
  private otherPhaseQueryVersion = 0;
  competitionModelFirstCall = true;

  public clashFilters = new BehaviorSubject<ClashFilter>({ cheTxNome: '' });
  minKeysGenerated?: number;
  events: IPage<IEventDto> = { content: [] };
  eventSearchText = '';
  eventPage = 0;
  readonly eventPageSize = 10;
  competitionSearchText = '';
  categorySearchText = '';
  federations: IPage<IListFederationDto> = { content: [] };
  selectedFederationIds: number[] = [];
  competitionsBlocks: IPage<ICompetitionBlockDto> = { content: [] };
  competitions: IPage<ICompetitionDto> = { content: [] };
  categories: IPage<ICategoryDto> = { content: [] };

  competitionModels: IPage<ICompetitionModelDto> = { content: [] };
  competitionModelsPage: PageRequest = { page: 0, size: 100 };
  public filters$ = provideFilter<CompetitionModelFilter>(
    FilterKeyEnum.COMPETITION_MODEL_FILTER,
  );

  yearsArray = [
    { key: '2023', value: 2023 },
    { key: '2024', value: 2024 },
    { key: '2025', value: 2025 },
    { key: '2026', value: 2026 },
  ];

  participants: ListAthleteEnrollmentsDto[] = [];
  participantsOtherPhase: ListAthleteEnrollmentsDto[] = [];
  allParticipantsList: ListAthleteEnrollmentsDto[] = [];

  private pendingAutoSelectCount?: number;

  private readonly eventService = inject(EventService);
  private readonly championshipService = inject(ChampionshipService);
  private readonly competitionBlockService = inject(CompetitionBlockService);
  private readonly stepParametrizationService = inject(
    StepParameterizationService,
  );
  private readonly federationService = inject(FederationService);
  private readonly enrollmentAthleteService = inject(EnrollmentAthleteService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly templateService = inject(SportParameterizationService);
  private readonly loadingService = inject(LoadingService);
  private readonly attachmentService = inject(AttachmentService);
  private readonly clashService = inject(ClashService);
  private readonly rodadasService = inject(RodadasService);
  private readonly confirmationModalService = inject(ConfirmationModalService);

  public enrollmentFilters = new BehaviorSubject<{ incTxResumo?: string }>({});
  public bannerPreview?: string;
  public readonly bannerAcceptedTypes = [
    'IMAGE/PNG',
    'IMAGE/JPEG',
    'IMAGE/JPG',
  ];

  stepTypes: { label: string; value: ParameterizationStepTypeEnum }[] = [];
  rodadaTypes = enumToDropdownOptions(TipoRodadaEnum);
  genreOptions = enumToDropdownOptions(GenreCateroryEnum);

  stepParameterizationForm = this.fb.group({
    petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias: this.fb.control<
      number | null
    >(null, [Validators.required, Validators.min(1)]),
    petTxNome: this.fb.control<string>('', [
      Validators.required,
      Validators.minLength(5),
      noWhitespaceValidator(),
    ]),
    petTxDescricao: this.fb.control<string>(''),
    petTxBanner: this.fb.control<string | null>(null),
    petTxExtensaoBanner: this.fb.control<AttachmentExtensionEnum | null>(null),
    catNrId: this.fb.control<number | null>(null, Validators.required),
    cheNrIdPrincipal: this.fb.control<number | null>(null),
    petNrMaxJogosDia: this.fb.control<number | null>(null),
    petNrIntervaloJogos: this.fb.control<number | null>(
      null,
      Validators.required,
    ),
    petNrDuracaoEmb: this.fb.control<number | null>(null, Validators.required),
    petNrMaxEmbSimultaneos: this.fb.control<number | null>(
      null,
      Validators.required,
    ),
    petBlTrocaOrdemConfronto: this.fb.control<boolean>(false),
    petTxTipo: this.fb.control<ParameterizationStepTypeEnum | null>(
      null,
      Validators.required,
    ),
    petNrQtdChe: this.fb.control<number | null>(null, Validators.required),
    petNrQuantidadeCabecasDeChave: this.fb.control<number | null>(
      null,
      Validators.required,
    ),
    petNrQtdInc: this.fb.control<number | null>(null, Validators.required),
    bloNrId: this.fb.control<number | null>(null, Validators.required),
    comNrId: this.fb.control<number | null>(null, Validators.required),
    eveNrId: this.fb.control<number | null>(null, Validators.required),
    petBlEmbDireto: this.fb.control<boolean>(false),
    petBlEdicaoBloqueada: this.fb.control<boolean>(false),
    petBlPermiteMesmoEstado: this.fb.control<boolean>(false),
    mocNrId: this.fb.control<number | null>(null),
    rodadaForms: this.fb.array<FormGroup<ControlsOf<RodadaForm>>>(
      [],
      [Validators.minLength(1), Validators.required],
    ),
    federacoesEtapaIds: this.fb.control<number[]>(
      [],
      [Validators.required, Validators.minLength(1)],
    ),
  });
  get petNrQtdInc() {
    return this.stepParameterizationForm.controls.petNrQtdInc;
  }
  get mocNrId() {
    return this.stepParameterizationForm.controls.mocNrId.value;
  }

  private createRodadaGroup(
    rodada?: Partial<RodadaDto>,
  ): FormGroup<ControlsOf<RodadaForm>> {
    const needDateValidators: boolean = !rodada?.rodNrId;

    const group = this.fb.group<ControlsOf<RodadaForm>>({
      rodTxNome: this.fb.control(
        rodada?.rodTxNome ?? null,
        Validators.required,
      ),
      rodTxTipoRodada: this.fb.control(
        rodada?.rodTxTipoRodada ?? null,
        Validators.required,
      ),
      rodDtInicio: this.fb.control(rodada?.rodDtInicio ?? null, [
        Validators.required,
      ]),
      rodDtFim: this.fb.control(rodada?.rodDtFim ?? null, [
        Validators.required,
      ]),
      rodNrOrdemExecucao: this.fb.control(
        rodada?.rodNrOrdemExecucao ?? this.rodadaForms.length + 1,
        Validators.required,
      ),
      entNrId: this.fb.control<number | null | undefined>(
        rodada?.rodNrId ?? null,
      ),
      entTxMetadado: this.fb.control<MetadataPutEnum | null | undefined>(
        rodada?.rodNrId ? MetadataPutEnum.INALTERADO : MetadataPutEnum.CRIADO,
      ),
    });

    const controls = group.controls;

    controls.rodDtFim.addValidators(this.validateRodadaEnd.bind(this));
    if (needDateValidators) {
      controls.rodDtInicio.addValidators(this.validateRodadaStart.bind(this));
    }

    controls.rodDtInicio.valueChanges.subscribe(() => {
      controls.rodDtFim.updateValueAndValidity({ onlySelf: true });
    });

    group.valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
      if (value.entTxMetadado == MetadataPutEnum.INALTERADO) {
        controls.entTxMetadado!.setValue(MetadataPutEnum.ALTERADO, {
          emitEvent: false,
        });
      }
    });

    return group;
  }

  private validateRodadaStart(
    control: AbstractControl,
  ): ValidationErrors | null {
    const value = control.value as string | null;

    if (!value) {
      return null;
    }

    const today = new Date().toISOString().split('T')[0];

    return value < today ? { initialDateBeforeToday: true } : null;
  }

  private validateRodadaEnd(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string | null;
    if (!value) {
      return null;
    }

    const parent = control.parent as FormGroup | null;
    const startValue = parent?.controls['rodDtInicio']?.value as string | null;
    if (!startValue) {
      return null;
    }

    return value < startValue ? { finalDateBeforeStart: true } : null;
  }

  adicionarRodada(): void {
    this.rodadaForms.push(this.createRodadaGroup());
  }

  removerRodada(index: number): void {
    if (this.rodadaForms.length < 1 && !this.mocNrId) return;

    const rodadaGroup = this.rodadaForms.at(index);
    const entTxMetadado: MetadataPutEnum | null | undefined =
      rodadaGroup.get('entTxMetadado')?.value;
    const entNrId: number | null | undefined =
      rodadaGroup.get('entNrId')?.value;
    const rodadaName: string = rodadaGroup.get('rodTxNome')?.value || '';

    if (entTxMetadado === MetadataPutEnum.CRIADO || entNrId == null) {
      this.rodadaForms.removeAt(index);
      return;
    }

    this.confirmationModalService.openModal({
      modalType: ConfirmationModalType.danger,
      confirmText: 'Deletar',
      cancelText: 'Cancelar',
      message: `Tem certeza que deseja deletar a rodada "${rodadaName}"?`,
      resourceName: 'Rodada',
      callbackExecuteAction: () => {
        this.confirmationModalService.closeModal();
        this.deleteRodadaFromServer(entNrId);
      },
    });
  }

  private deleteRodadaFromServer(entNrId: number): void {
    this.rodadasService
      .deletarRodadaEReordenar(entNrId, this.petNrId!)
      .subscribe({
        next: () => {
          this.loadRodadas(this.petNrId!);
          this.snackbarService.showSuccess('Rodada deletada com sucesso!');
        },
        error: (err) => {
          this.messageErrorResolver.resolveMessage(err);
        },
      });
  }

  printRodadas(): void {
    console.log(this.rodadaForms);
  }

  rodadaOrigemForm = this.fb.group({
    modo: this.fb.control<'criar' | 'existente'>('criar', {
      nonNullable: true,
    }),
  });

  get isModoRodadaExistente(): boolean {
    return this.rodadaOrigemForm.controls.modo.value === 'existente';
  }

  parametrizacoesCompartilhaveis: IPage<ISimpleStepParameterizationDto> = {
    content: [],
  };
  petNrIdOrigemSelecionado: number | null = null;
  rodadasDaParametrizacaoOrigem: RodadaDto[] = [];
  rodadasSelecionadasParaVincular = new Set<number>();

  isOtherStepForm = this.fb.group({
    isOutherStep: ['nao', Validators.required],
    fase: this.fb.control<number | null>(null),
    chave: this.fb.control<number | null>(null),
  });

  private patchIdsToFormDeferred(): void {
    Promise.resolve().then(() => {
      this.stepParameterizationForm.patchValue({
        eveNrId: this.eveNrId ?? null,
        bloNrId: this.bloNrId ?? null,
        comNrId: this.comNrId ?? null,
      });
    });
  }

  ngOnInit(): void {
    //TODO impl set years array
    let eventsLoaded = false;
    this.allParticipantsList = [...this.participantsOtherPhase];
    this.activatedRoute.paramMap.subscribe((params) => {
      const petNrId = params.get('petNrId');
      const fromGroupKey =
        this.activatedRoute.snapshot.queryParamMap.get('fromGroupKey');
      if (petNrId) {
        this.petNrId = +petNrId;
        this.isEditing = true;
        this.getStepParametrizationById();
        eventsLoaded = true;
      }
      this.listenQtdParticipantsStepParametrization();
      if (fromGroupKey) this.onStepChange(3);
    });
    if (!eventsLoaded) this.loadEvents();
    this.loadFederations();
    this.stepTypes = Object.values(ParameterizationStepTypeEnum).map(
      (value) => ({
        label: this.formatEnumLabel(value),
        value: value,
      }),
    );
    this.initOtherPhaseFilterBindings();
    this.getCompetitionTemplates();
    const controls = this.stepParameterizationForm.controls;
    controls.mocNrId.valueChanges
      .pipe(
        startWith(controls.mocNrId.value),
        distinctUntilChanged(),
        this.takeUntilDestroy(),
      )
      .subscribe((mocNrId) => {
        this.updateRodadaFormsValidators(mocNrId);
      });
    this.rodadaOrigemForm.controls.modo.valueChanges
      .pipe(distinctUntilChanged(), this.takeUntilDestroy())
      .subscribe((modo) => {
        if (modo === 'existente') {
          this.loadParametrizacoesCompartilhaveis();
        } else {
          this.resetSelecaoRodadaExistente();
        }
      });
  }

  private updateRodadaFormsValidators(
    mocNrId: number | null | undefined,
  ): void {
    if (mocNrId) {
      this.rodadaForms.clearValidators();
    } else {
      this.rodadaForms.setValidators([
        Validators.minLength(1),
        Validators.required,
      ]);
    }
    this.rodadaForms.updateValueAndValidity();
  }

  selectedYear?: any;

  onYearChange(ano: number) {
    this.selectedYear = ano;
    this.loadEvents();
  }

  private getCompetitionTemplates(): void {
    this.stepParameterizationForm.get('comNrId')?.valueChanges.subscribe({
      next: (comNrId) => {
        if (!comNrId) {
          this.competitionModels = { content: [] };
          return;
        }
        const espNrId = this.competitions.content?.find(
          (competicao) => competicao.comNrId === comNrId,
        )?.comObjEsporte?.espNrId;
        if (!this.competitionModelFirstCall) return;
        if (espNrId) {
          this.competitionModelFirstCall = false;
          this.stepParametrizationService
            .getCompetitionModels$(
              { espNrId: espNrId },
              this.competitionModelsPage,
            )
            .subscribe({
              next: (res) => {
                this.competitionModels = res ?? { content: [] };
                this.cdr.detectChanges();
              },
              error: (err) => this.messageErrorResolver.resolveMessage(err),
            });
        }
      },
    });
  }

  private listenQtdParticipantsStepParametrization() {
    this.stepParameterizationForm.controls.petNrQtdInc.valueChanges.subscribe(
      (petNrQtdInc) => {
        this.validateQtdParticipantsStepParamatrization(petNrQtdInc!);
      },
    );
  }
  validateQtdParticipantsStepParamatrization(qtdMaxParticipants: number) {
    this.qtdMaxParticipantsStepParametrization = qtdMaxParticipants;
  }

  private loadFasesForOtherStep(): void {
    const filters: StepParametrizationFilter = {
      eveNrId: this.eveNrId!,
      bloNrId: this.bloNrId!,
      comNrId: this.comNrId!,
      catNrId: this.catNrId!,
      petNrIdAtual: this.petNrId,
    };

    this.stepParametrizationService
      .getSimpleStepParametrization$(filters, this.fasePage)
      .subscribe({
        next: (res) => {
          this.faseOptions =
            res ?? ({ content: [] } as IPage<ISimpleStepParameterizationDto>);
          this.cdr.detectChanges();
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  private loadClashByFase(page: number, petNrId: number) {
    const filter: ClashFilter = { ...this.clashFilters.getValue(), petNrId };
    this.clashService.getClashs(filter, { page, size: 100 }).subscribe({
      next: (res) => {
        this.clashOptions = res ?? ({ content: [] } as IPage<GroupKeyDto>);
        this.cdr.detectChanges();
      },
      error: (err) => this.messageErrorResolver.resolveMessage(err),
    });
  }
  public filterCompetitionModelByName(mocTxNome: string): void {
    this.filters$.patch({ mocTxNome: mocTxNome || undefined });
  }

  onSwitchStateChange(allowed: boolean) {
    this.isBlocked = !allowed;
    this.stepParameterizationForm.patchValue(
      { petBlEdicaoBloqueada: !allowed },
      { emitEvent: false },
    );

    if (this.isEditing) {
      this.stepParametrizationService
        .blockStepParametrizationEdit(this.petNrId!, this.isBlocked)
        .subscribe({
          next: () =>
            this.snackbarService.showSuccess(
              this.isBlocked
                ? 'Edição da Etapa Bloqueada com Sucesso'
                : 'Edição da Etapa Permitida com Sucesso',
            ),
          error: (error) => this.messageErrorResolver.resolveMessage(error),
        });
    }
  }

  get permiteMesmoEstado() {
    return (
      this.stepParameterizationForm.controls.petBlPermiteMesmoEstado.value ??
      false
    );
  }

  onSwitchPermiteMesmoEstadoChange(allowed: boolean) {
    this.stepParameterizationForm.controls.petBlPermiteMesmoEstado.setValue(
      allowed,
    );
  }

  private initOtherPhaseFilterBindings(): void {
    if (this.otherPhaseBindingsInit) return;
    this.otherPhaseBindingsInit = true;
    this.isOtherStepForm.get('isOutherStep')?.valueChanges.subscribe({
      next: (value) => {
        this.isOtherStepValue = value === 'sim';

        if (this.isOtherStepValue) {
          this.isOtherStepForm.patchValue(
            { fase: null, chave: null },
            { emitEvent: false },
          );
          this.clashOptions = { content: [] } as IPage<GroupKeyDto>;

          if (this.hasContextForOtherPhase()) {
            this.loadFasesForOtherStep();
          } else {
            this.shouldLoadFasesWhenReady = true;
          }
        } else {
          this.faseOptions = {
            content: [],
          } as IPage<ISimpleStepParameterizationDto>;
          this.clashOptions = { content: [] } as IPage<GroupKeyDto>;
          this.participantsOtherPhase = [];
          this.isOtherStepForm.patchValue(
            { fase: null, chave: null },
            { emitEvent: false },
          );
          this.shouldLoadFasesWhenReady = false;
          this.cdr.detectChanges();
        }
      },
    });

    this.isOtherStepForm.get('fase')?.valueChanges.subscribe({
      next: (petNrId: number | null) => {
        this.isOtherStepForm.patchValue({ chave: null }, { emitEvent: false });
        this.clashOptions = { content: [] } as IPage<GroupKeyDto>;

        if (petNrId) {
          this.clashFilters.next({ ...this.clashFilters.getValue(), petNrId });
          this.loadClashByFase(0, petNrId);
        } else {
          this.cdr.detectChanges();
        }
      },
    });

    this.isOtherStepForm.get('chave')?.valueChanges.subscribe({
      next: (cheNrId: number | null) => {
        const petNrId = this.isOtherStepForm.get('fase')?.value ?? null;
        if (!petNrId) return;
        this.applyOtherPhaseFilter(petNrId, cheNrId ?? undefined);
      },
    });
  }

  private applyOtherPhaseFilter(petNrId: number, cheNrId?: number): void {
    const currentSearch = this.enrollmentFilters.getValue().incTxResumo;

    const filter: any = {
      eveNrId: this.eveNrId!,
      bloNrId: this.bloNrId!,
      comNrId: this.comNrId!,
      catNrId: this.catNrId!,
      incTxResumo: currentSearch,
      petNrId,
      ...(cheNrId != null ? { cheNrId } : {}),
    };

    const myVersion = ++this.otherPhaseQueryVersion;

    this.participantsOtherPhase = [];
    this.allParticipantsList = [...this.selectedEntries];
    this.cdr.detectChanges();

    this.enrollmentAthleteService
      .getAtletesByFaseEhClash(
        {
          catNrId: filter.catNrId,
          petNrId: petNrId,
          cheNrId: cheNrId,
        },
        PageRequest.default(),
      )
      .subscribe({
        next: (res) => {
          if (myVersion !== this.otherPhaseQueryVersion) return;

          let list = res.content ?? [];

          if (cheNrId != null) {
            list = list.filter((p) => (p as any).cheNrId === cheNrId);
          }

          const selectedIne = new Set(
            this.selectedEntries.map((s) => (s as any).ineNrId).filter(Boolean),
          );
          this.participantsOtherPhase = list.filter(
            (p) => !selectedIne.has((p as any).ineNrId),
          );

          this.allParticipantsList = [
            ...this.participantsOtherPhase,
            ...this.selectedEntries,
          ];

          if (
            this.autoSelectEnabled &&
            this.pendingAutoSelectCount &&
            this.participantsOtherPhase?.length
          ) {
            this.applyModelAutoSelection(this.pendingAutoSelectCount);
            this.pendingAutoSelectCount = undefined;
          }

          this.cdr.detectChanges();
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  onCompetitionModelChange(value: ICompetitionModelDto | number | null) {
    const mocNrId =
      typeof value === 'number' ? value : (value?.mocNrId ?? null);
    this.stepParameterizationForm.patchValue({ mocNrId: mocNrId });

    if (value && typeof value === 'object') {
      this.autoSelectEnabled = true;
      const selectedStepType = this.stepTypes.find(
        (type) => type.value === value.mocTxFormatoFase,
      );

      this.stepParameterizationForm.patchValue({
        petTxTipo: selectedStepType ? selectedStepType.value : null,
        petNrQtdChe: value.mocNrQtdChaves,
        petNrQtdInc: value.mocNrQtdInscritos,
      });

      this.stepParameterizationForm.get('petTxTipo')?.disable();
      this.stepParameterizationForm.get('petNrQtdChe')?.disable();
      this.stepParameterizationForm.get('petNrQtdInc')?.disable();
      const limit = value.mocNrQtdInscritos;
      this.pendingAutoSelectCount = limit;
      const pool = this.isOtherStepValue
        ? this.participantsOtherPhase
        : this.participants;
      if (pool?.length) {
        this.applyModelAutoSelection(limit);
        this.pendingAutoSelectCount = undefined;
      }
    } else {
      this.autoSelectEnabled = false;
      this.stepParameterizationForm.get('petTxTipo')?.enable();
      this.stepParameterizationForm.get('petNrQtdChe')?.enable();
      this.stepParameterizationForm.get('petNrQtdInc')?.enable();
    }
  }
  private applyModelAutoSelection(limit?: number): void {
    if (!limit || !this.autoSelectEnabled) return;
    if (this.selectedEntries.length > 0) return;
    const isOther = this.isOtherStepValue;
    const pool = isOther
      ? [...this.participantsOtherPhase]
      : [...this.participants];

    const already = new Set(
      this.selectedEntries.map((p) => (p.insNrId ?? (p as any).ineNrId)!),
    );
    const picked: TopSeedParticipant[] = [];
    for (const p of pool) {
      const id = (p.insNrId ?? (p as any).ineNrId)!;
      if (already.has(id)) continue;
      picked.push(p);
      if (this.selectedEntries.length + picked.length >= limit) break;
    }

    this.selectedEntries = [...this.selectedEntries, ...picked].slice(0, limit);

    const pickedIds = new Set(
      picked.map((p) => (p.insNrId ?? (p as any).ineNrId)!),
    );
    if (isOther) {
      this.participantsOtherPhase = pool.filter(
        (p) => !pickedIds.has((p.insNrId ?? (p as any).ineNrId)!),
      );
    } else {
      this.participants = pool.filter(
        (p) => !pickedIds.has((p.insNrId ?? (p as any).ineNrId)!),
      );
    }

    this.allParticipantsList = isOther
      ? [...this.participantsOtherPhase, ...this.selectedEntries]
      : [...this.participants, ...this.selectedEntries];

    this.cdr.detectChanges();
  }

  formatEnumLabel(enumValue: string): string {
    const map = {
      ROUND_ROBIN: 'Round Robin',
      ELIMINATORIA_SIMPLES: 'Eliminatória Simples',
      ELIMINATORIA_DUPLA: 'Eliminatória Dupla',
      GRUPO: 'Grupo',
    } as Record<string, string>;
    return map[enumValue] || enumValue;
  }
  loadEvents(page: number = 0): void {
    this.eventPage = page;
    const trimmed = this.eventSearchText?.trim();
    const filter = {
      ano: this.selectedYear?.value ?? undefined,
      ...(trimmed ? { eveTxNome: trimmed } : {}),
    };
    this.eventService
      .getAllEventsOwner(filter, page, this.eventPageSize)
      .subscribe({
        next: (res) => {
          this.events = res;
          this.cdr.detectChanges();
          const eveNrId = this.stepParameterizationForm.get('eveNrId')?.value;
          if (eveNrId) {
            this.stepParameterizationForm.patchValue({ eveNrId });
          }
        },
        error: (err) => {
          this.messageErrorResolver.resolveMessage(err);
        },
      });
  }

  onEventSearch(text: string): void {
    this.eventSearchText = text;
    this.loadEvents(0);
  }

  onEventPageChange(page: number): void {
    this.loadEvents(page);
  }



  private loadFederations(): void {
    this.federationService.getAllFederations(undefined, 0, 100).subscribe({
      next: (res) => {
        this.federations = res ?? { content: [] };
        this.cdr.detectChanges();
      },
    });
  }

  onFederationsChange(fedNrIds: number[]): void {
    this.selectedFederationIds = fedNrIds;
    this.stepParameterizationForm.controls.federacoesEtapaIds.setValue(
      fedNrIds,
    );
  }

  onBannerBase64Change(base64: string): void {
    this.bannerPreview = base64;
    this.stepParameterizationForm.controls.petTxBanner.setValue(base64);
  }

  onBannerFormatChange(format: AttachmentExtensionEnum): void {
    this.stepParameterizationForm.controls.petTxExtensaoBanner.setValue(format);
  }

  private carregarPreviewBanner(referenciaBanner?: string): void {
    this.bannerPreview = undefined;
    if (!referenciaBanner) return;

    this.attachmentService.getAttachmentByUrl(referenciaBanner).subscribe({
      next: (base64) => {
        this.bannerPreview = base64;
        this.cdr.detectChanges();
      },
      error: () => {
        this.bannerPreview = undefined;
        this.cdr.detectChanges();
      },
    });
  }

  removeAllParticipants(): void {
    (this.isOtherStepValue
      ? this.selectedEntriesOtherPhase
      : this.selectedEntries
    ).forEach((item) => {
      this.isOtherStepValue
        ? this.removeParticipantOhterPhase(item)
        : this.removeParticipant(item);
    });
  }

  submitSportParameterization(ettNrId: number) {
    this.ettNrIdSportTemplateSaved = ettNrId;

    this.cdr.detectChanges();

    if (this.isEditing && this.petNrId) {
      this.stepParametrizationService
        .updateTemplateId(this.petNrId!, ettNrId)
        .subscribe({
          next: () => {},
          error: (err) => {
            this.messageErrorResolver.resolveMessage(err);
          },
        });
    }
  }

  onChangeEmbateDireto(event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = target.value;
    const booleanValue = value === 'true';
    this.petBlEmbDireto = booleanValue;
  }

  onStepChange(i: number) {
    this.currentStep = i;
  }

  loadCompetitionBlocks(eventId: number) {
    this.resetBlocks();
    this.eventService.getAllCompetitionBlocksByEvent$(eventId).subscribe({
      next: (res) => {
        this.competitionsBlocks = res ?? { content: [] };
        this.cdr.detectChanges();
        if (this.bloNrId != null) {
          this.stepParameterizationForm
            .get('bloNrId')!
            .setValue(Number(this.bloNrId));
        }
      },
      error: (err) => {
        this.resetBlocks();
        this.messageErrorResolver.resolveMessage(err);
      },
    });
  }

  loadCompetitions(blockId: number, page = 0) {
    this.resetCompetitions();
    const trimmed = this.competitionSearchText?.trim();
    this.competitionBlockService
      .getAllCompetitionByBlocks(
        blockId,
        page,
        20,
        undefined,
        undefined,
        trimmed || undefined,
      )
      .subscribe({
        next: (res) => {
          this.competitions = res ?? { content: [] };
          this.cdr.detectChanges();

          if (this.comNrId != null) {
            this.stepParameterizationForm
              .get('comNrId')!
              .setValue(Number(this.comNrId));
          }
        },
        error: (err) => {
          this.resetCompetitions();
          this.messageErrorResolver.resolveMessage(err);
        },
      });
  }

  onCompetitionSearch(text: string): void {
    this.competitionSearchText = text;
    if (this.bloNrId) this.loadCompetitions(this.bloNrId, 0);
  }

  onCompetitionPageChange(page: number): void {
    if (this.bloNrId) this.loadCompetitions(this.bloNrId, page);
  }



  private formatGenreLabel(sexo?: GenreCateroryEnum): string {
    if (!sexo) return '';
    const option = this.genreOptions.find((opt) => opt.value === sexo);
    return option?.label ?? sexo.toString();
  }

  loadCategories(competitionId: number, page = 0, callback?: () => void) {
    this.resetCategories();
    const trimmed = this.categorySearchText?.trim();
    this.championshipService
      .getAllCategoryByCompetition(competitionId, page, 20, trimmed || undefined)
      .subscribe({
        next: (res) => {
          const content = (res?.content ?? []).map((cat) => ({
            ...cat,
            catTxNomeComNaipe: cat.catTxSexo
              ? `${cat.catTxNome} - ${this.formatGenreLabel(cat.catTxSexo)}`
              : (cat.catTxNome ?? ''),
          }));
          this.categories = { ...res, content };
          this.cdr.detectChanges();
          if (callback) callback();
        },
        error: (err) => {
          this.resetCategories();
          this.messageErrorResolver.resolveMessage(err);
        },
      });
  }

  onCategorySearch(text: string): void {
    this.categorySearchText = text;
    if (this.comNrId) this.loadCategories(this.comNrId, 0);
  }

  onCategoryPageChange(page: number): void {
    if (this.comNrId) this.loadCategories(this.comNrId, page);
  }



  private setRodadasOnForm(rodadas: RodadaDto[]): void {
    this.rodadaForms.clear();
    if (!rodadas?.length) return;

    rodadas
      .sort((a, b) => a.rodNrOrdemExecucao - b.rodNrOrdemExecucao)
      .forEach((rodada) =>
        this.rodadaForms.push(
          this.createRodadaGroup({
            rodNrId: rodada.rodNrId,
            rodTxNome: rodada.rodTxNome,
            rodTxTipoRodada: rodada.rodTxTipoRodada,
            rodDtInicio: rodada.rodDtInicio,
            rodDtFim: rodada.rodDtFim,
            rodNrOrdemExecucao: rodada.rodNrOrdemExecucao,
          }),
        ),
      );
    this.cdr.detectChanges();
  }

  private loadRodadas(petNrId: number): void {
    this.rodadasService.buscarRodadasPorEtapa(petNrId).subscribe({
      next: (res) => {
        const rodadas = res?.response ?? [];
        this.setRodadasOnForm(rodadas);
      },
      error: (err) => this.messageErrorResolver.resolveMessage(err),
    });
  }

  private loadParametrizacoesCompartilhaveis(): void {
    if (!this.eveNrId || !this.comNrId) return;
    const filtro: StepParametrizationFilter = {
      eveNrId: this.eveNrId,
      comNrId: this.comNrId,
      petNrIdAtual: this.petNrId,
    };
    this.stepParametrizationService
      .getSimpleStepParametrization$(filtro, { page: 0, size: 100 })
      .subscribe({
        next: (res) => {
          this.parametrizacoesCompartilhaveis = res ?? { content: [] };
          this.cdr.detectChanges();
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  private resetSelecaoRodadaExistente(): void {
    this.parametrizacoesCompartilhaveis = { content: [] };
    this.petNrIdOrigemSelecionado = null;
    this.rodadasDaParametrizacaoOrigem = [];
    this.rodadasSelecionadasParaVincular.clear();
  }

  onParametrizacaoOrigemChange(
    value: ISimpleStepParameterizationDto | number | null,
  ): void {
    const petNrIdOrigem =
      typeof value === 'number' ? value : (value?.petNrId ?? null);
    this.petNrIdOrigemSelecionado = petNrIdOrigem ?? null;
    this.rodadasDaParametrizacaoOrigem = [];
    this.rodadasSelecionadasParaVincular.clear();

    if (!petNrIdOrigem) {
      this.cdr.detectChanges();
      return;
    }

    this.rodadasService.buscarRodadasPorEtapa(petNrIdOrigem).subscribe({
      next: (res) => {
        const jaAdicionadas = new Set(
          this.rodadaForms.controls
            .map((c) => c.get('entNrId')?.value)
            .filter((id): id is number => id != null),
        );
        this.rodadasDaParametrizacaoOrigem = (res?.response ?? []).filter(
          (r) => !jaAdicionadas.has(r.rodNrId),
        );
        this.cdr.detectChanges();
      },
      error: (err) => this.messageErrorResolver.resolveMessage(err),
    });
  }

  isRodadaSelecionadaParaVincular(rodNrId: number): boolean {
    return this.rodadasSelecionadasParaVincular.has(rodNrId);
  }

  toggleRodadaParaVincular(rodNrId: number): void {
    if (this.rodadasSelecionadasParaVincular.has(rodNrId)) {
      this.rodadasSelecionadasParaVincular.delete(rodNrId);
    } else {
      this.rodadasSelecionadasParaVincular.add(rodNrId);
    }
  }

  vincularRodadasSelecionadas(): void {
    if (!this.rodadasSelecionadasParaVincular.size) return;

    const selecionadas = this.rodadasDaParametrizacaoOrigem.filter((r) =>
      this.rodadasSelecionadasParaVincular.has(r.rodNrId),
    );

    selecionadas.forEach((rodada) => {
      const group = this.createRodadaGroup(rodada);
      group.controls.rodTxNome.disable();
      group.controls.rodTxTipoRodada.disable();
      group.controls.rodDtInicio.disable();
      group.controls.rodDtFim.disable();
      group.controls.rodNrOrdemExecucao.disable();
      this.rodadaForms.push(group);
    });

    this.rodadasDaParametrizacaoOrigem =
      this.rodadasDaParametrizacaoOrigem.filter(
        (r) => !this.rodadasSelecionadasParaVincular.has(r.rodNrId),
      );
    this.rodadasSelecionadasParaVincular.clear();
    this.cdr.detectChanges();
  }

  isRodadaHerdada(rodada: FormGroup<ControlsOf<RodadaForm>>): boolean {
    return rodada.controls.rodTxNome.disabled;
  }

  private getStepParametrizationById(): void {
    const petNrId = this.petNrId;
    if (!petNrId) throw new Error('PET NR ID NAO ENCONTRADO');
    this.stepParametrizationService
      .getStepParametrizationById$(petNrId)
      .subscribe({
        next: (stepParametrization) => {
          this.ettNrIdSportTemplateSaved = stepParametrization.ettNrId;
          this.comNrId = stepParametrization.petObjCategoria?.comNrId;
          this.catNrId = stepParametrization.petObjCategoria?.catNrId;
          this.isKeysGenerated = stepParametrization.petBlChavesGeradas;
          this.qtdChaves = stepParametrization.petNrQtdChe;
          if (!this.comNrId) return;

          this.championshipService.getCompetitionById(this.comNrId).subscribe({
            next: (competition) => {
              this.eveNrId = competition.eveNrId;
              this.bloNrId = competition.bloNrId;
              this.espNrId = competition.comObjEsporte?.espNrId;

              this.patchIdsToFormDeferred();

              this.loadEvents();
              this.loadCompetitionBlocks(this.eveNrId!);
              this.loadCompetitions(this.bloNrId!);

              this.loadCategories(this.comNrId!, 0, () => {
                this.stepParameterizationForm.patchValue(
                  {
                    petTxNome: stepParametrization.petTxNome,
                    petTxDescricao: stepParametrization.petTxDescricao,
                    petTxBanner: stepParametrization.petTxBanner ?? null,
                    cheNrIdPrincipal:
                      stepParametrization.petObjChavePrincipal?.cheNrId,
                    petNrMaxJogosDia: stepParametrization.petNrMaxJogosDia,
                    petNrIntervaloJogos:
                      stepParametrization.petNrIntervaloJogos,
                    petNrDuracaoEmb: stepParametrization.petNrDuracaoEmb,
                    petNrMaxEmbSimultaneos:
                      stepParametrization.petNrMaxEmbSimultaneos,
                    petBlTrocaOrdemConfronto:
                      stepParametrization.petBlTrocaOrdemConfronto,
                    petTxTipo: stepParametrization.petTxTipo,
                    petNrQtdChe: stepParametrization.petNrQtdChe,
                    petNrQtdInc: stepParametrization.petNrQtdInc,
                    petNrQuantidadeCabecasDeChave:
                      stepParametrization.petNrQuantidadeCabecasDeChave,
                    petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias:
                      stepParametrization.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias,
                    petBlPermiteMesmoEstado:
                      stepParametrization.petBlPermiteMesmoEstado ?? false,
                    comNrId: this.comNrId,
                    catNrId: this.catNrId,
                    petBlEmbDireto: stepParametrization.petBlEmbDireto ?? false,
                    mocNrId: stepParametrization.mocNrId,
                  },
                  { emitEvent: false },
                );
                this.carregarPreviewBanner(stepParametrization.petTxBanner);
                if (
                  this.isOtherStepForm.get('isOutherStep')?.value === 'sim' &&
                  this.hasContextForOtherPhase()
                ) {
                  this.isOtherStepValue = true;
                  this.loadFasesForOtherStep();
                }
                this.petBlEmbDireto =
                  stepParametrization.petBlEmbDireto ?? false;
                // this.petBlEdicaoBloqueada = !stepParametrization.petBlEdicaoBloqueada;
                // this.stepParameterizationForm.patchValue({
                //   petBlEdicaoBloqueada: !stepParametrization.petBlEdicaoBloqueada,
                // });
                this.isBlocked = !!stepParametrization.petBlEdicaoBloqueada;
                this.stepParameterizationForm.patchValue(
                  { petBlEdicaoBloqueada: this.isBlocked },
                  { emitEvent: false },
                );
                this.stepParameterizationForm.patchValue(
                  {
                    petBlEdicaoBloqueada: this.isBlocked,
                  },
                  { emitEvent: false },
                );
                if (stepParametrization.mocNrId) {
                  this.stepParameterizationForm.get('petTxTipo')?.disable();
                  this.stepParameterizationForm.get('petNrQtdInc')?.disable();
                  this.stepParameterizationForm.get('mocNrId')?.disable();

                  if (this.isEditing) {
                    this.stepParameterizationForm.get('petNrQtdChe')?.enable();
                  } else {
                    this.stepParameterizationForm.get('petNrQtdChe')?.disable();
                  }
                } else {
                  this.stepParameterizationForm.get('petTxTipo')?.enable();
                  this.stepParameterizationForm.get('petNrQtdChe')?.enable();
                  this.stepParameterizationForm.get('petNrQtdInc')?.enable();
                  this.stepParameterizationForm.get('mocNrId')?.enable();
                }
                this.updateRodadaFormsValidators(stepParametrization.mocNrId);

                this.selectedEntries =
                  stepParametrization.petListInscricoesEtapa?.map((i) => ({
                    insNrId: i.ineObjInscricao?.incNrId!,
                    insTxResumo: i.ineObjInscricao?.incTxResumo ?? '',
                    isCabecaChave: i.incBlCabecaChave ?? false,
                  })) ?? [];
                this.selectedFederationIds =
                  stepParametrization.petListFederacoesEtapa?.map(
                    (f) => f.fedNrId!,
                  ) ?? [];
                this.stepParameterizationForm.controls.federacoesEtapaIds.setValue(
                  this.selectedFederationIds,
                  { emitEvent: false },
                );
                this.loadEnrollmentsByFilters(this.catNrId);
                this.loadRodadas(petNrId);
                this.cdr.detectChanges();
                this.initOtherPhaseFilterBindings();
                if (this.isOtherStepValue && this.hasContextForOtherPhase()) {
                  this.loadFasesForOtherStep();
                  this.shouldLoadFasesWhenReady = false;
                }
              });
            },
            error: (err) => this.messageErrorResolver.resolveMessage(err),
          });
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }
  private clearOtherPhaseFilter(): void {
    this.isOtherStepForm.patchValue({ chave: null }, { emitEvent: false });
    this.clashOptions = { content: [] } as IPage<GroupKeyDto>;

    this.participantsOtherPhase = [];

    this.allParticipantsList = this.isOtherStepValue
      ? [...this.selectedEntries]
      : [...this.participants, ...this.selectedEntries];

    this.cdr.detectChanges();
  }
  onFaseChange(value: ISimpleStepParameterizationDto | number | null): void {
    const petNrId =
      typeof value === 'number' ? value : (value?.petNrId ?? null);

    this.isOtherStepForm.patchValue({ chave: null }, { emitEvent: false });
    this.clashOptions = { content: [] } as IPage<GroupKeyDto>;

    if (!petNrId) {
      this.clearOtherPhaseFilter();
      return;
    }

    this.clashFilters.next({ ...this.clashFilters.getValue(), petNrId });
    this.loadClashByFase(0, petNrId);

    this.applyOtherPhaseFilter(petNrId, undefined);
  }

  onChaveChange(value: GroupKeyDto | number | null): void {
    const cheNrId =
      typeof value === 'number' ? value : (value?.cheNrId ?? null);
    const petNrId = this.isOtherStepForm.get('fase')?.value ?? null;

    this.isOtherStepForm.patchValue(
      { chave: cheNrId ?? null },
      { emitEvent: false },
    );

    if (!petNrId) {
      this.clearOtherPhaseFilter();
      return;
    }

    this.applyOtherPhaseFilter(petNrId, cheNrId ?? undefined);
  }

  private shouldLoadFasesWhenReady = false;

  private hasContextForOtherPhase(): boolean {
    return !!(this.eveNrId && this.bloNrId && this.comNrId && this.catNrId);
  }
  private resetParticipants(): void {
    this.participants = [];
    this.participantsOtherPhase = [];
    this.selectedEntries = [];
    this.allParticipantsList = [];
    this.selectedEntriesOtherPhase = [];
    this.isOtherStepForm.patchValue({
      isOutherStep: 'nao',
      fase: null,
      chave: null,
    });
    this.isOtherStepValue = false;
    this.cdr.detectChanges();
  }

  private resetBlocks(): void {
    this.competitionsBlocks = { content: [] };
  }
  private resetCompetitions(): void {
    this.competitions = { content: [] };
  }
  private resetCategories(): void {
    this.categories = { content: [] };
  }

  onEventChange(event: IEventDto | null) {
    const eventId = event?.eveNrId;

    this.bloNrId = undefined;
    this.comNrId = undefined;
    this.catNrId = undefined;

    this.stepParameterizationForm.patchValue(
      {
        bloNrId: null,
        comNrId: null,
        catNrId: null,
      },
      { emitEvent: false },
    );

    this.resetBlocks();
    this.resetCompetitions();
    this.resetCategories();
    this.resetParticipants();
    this.competitionSearchText = '';
    this.categorySearchText = '';

    this.eveNrId = eventId;

    if (eventId) {
      this.loadCompetitionBlocks(eventId);
    } else {
      this.cdr.detectChanges();
    }
  }

  onBlockChange(block: ICompetitionBlockDto | null) {
    const blockId = block?.bloNrId;

    this.comNrId = undefined;
    this.catNrId = undefined;

    this.stepParameterizationForm.patchValue(
      {
        comNrId: null,
        catNrId: null,
      },
      { emitEvent: false },
    );

    this.resetCompetitions();
    this.resetCategories();
    this.resetParticipants();
    this.competitionSearchText = '';
    this.categorySearchText = '';

    this.bloNrId = blockId;

    if (blockId) {
      this.loadCompetitions(blockId);
    } else {
      this.cdr.detectChanges();
    }
  }

  chaveEmbateFormList?: ChaveEmbateForm[] = [];

  keysFormChange(event: ChaveEmbateForm[]) {
    this.chaveEmbateFormList = event;
  }

  onCategoryChange(cat: ICategoryDto | null) {
    this.catNrId = cat?.catNrId;

    this.resetParticipants();

    if (this.catNrId) {
      this.loadEnrollmentsByFilters(this.catNrId);
      if (
        this.isOtherStepValue &&
        this.hasContextForOtherPhase() &&
        (this.shouldLoadFasesWhenReady || !this.faseOptions?.content?.length)
      ) {
        this.loadFasesForOtherStep();
        this.shouldLoadFasesWhenReady = false;
      }
    }
  }

  onCompetitionChange(comp: ICompetitionDto | null) {
    const compId = comp?.comNrId;

    this.catNrId = undefined;
    this.espNrId = undefined;

    this.stepParameterizationForm.patchValue(
      { catNrId: null },
      { emitEvent: false },
    );

    this.resetCategories();
    this.resetParticipants();
    this.categorySearchText = '';

    this.comNrId = compId;
    this.espNrId = comp?.comObjEsporte?.espNrId;

    if (compId) {
      this.loadCategories(compId);

      const fedNrId = this.authService.getCurrentValueOfTokenData()?.fedNrId;
      /*if (fedNrId && this.espNrId) {
        this.loadDefaultTemplateInParent(fedNrId, this.espNrId);
      }*/
    } else {
      this.cdr.detectChanges();
    }
  }

  loadEnrollmentsByFilters(catNrId?: number): void {
    // const rawCatId = this.stepParameterizationForm.controls.catNrId.value;

    const currentSearch = this.enrollmentFilters.getValue().incTxResumo;
    console.log(catNrId);
    const filter = {
      eveNrId: this.eveNrId!,
      bloNrId: this.bloNrId!,
      comNrId: this.comNrId!,
      catNrId: catNrId,
      incTxResumo: currentSearch,
    };

    this.enrollmentAthleteService
      .findAllAthleteEnrollments(filter, 0, 100)
      .subscribe({
        next: (res) => {
          this.participants = res.content ?? [];
          this.allParticipantsList = [...this.participants];
          const selected = this.selectedEntries.map(
            (obj: TopSeedParticipant) => obj.insNrId,
          );
          this.participants = this.participants.filter(
            (p) => !selected.includes(p.insNrId),
          );
          if (
            this.autoSelectEnabled &&
            this.pendingAutoSelectCount &&
            (this.participants.length || this.participantsOtherPhase.length)
          ) {
            this.applyModelAutoSelection(this.pendingAutoSelectCount);
            this.pendingAutoSelectCount = undefined;
          }

          this.allParticipantsList = this.isOtherStepValue
            ? [...this.participantsOtherPhase, ...this.selectedEntries]
            : [...this.participants, ...this.selectedEntries];
          this.cdr.detectChanges();
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  filterByName(incTxResumo: string): void {
    this.enrollmentFilters.next({
      ...this.enrollmentFilters.getValue(),
      incTxResumo,
    });
    this.loadEnrollmentsByFilters();
  }

  private buildStepForms(): ParameterizationPostForm {
    const rawForm = this.stepParameterizationForm.getRawValue();

    const form = ParameterizationPostForm.of({
      petTxNome: rawForm.petTxNome ?? undefined,
      petTxDescricao: rawForm.petTxDescricao ?? undefined,
      petTxBanner: rawForm.petTxBanner ?? undefined,
      petTxExtensaoBanner: rawForm.petTxExtensaoBanner ?? undefined,
      catNrId: rawForm.catNrId ?? undefined,
      cheNrIdPrincipal: rawForm.cheNrIdPrincipal ?? undefined,
      petNrMaxJogosDia: rawForm.petNrMaxJogosDia ?? undefined,
      petNrIntervaloJogos: rawForm.petNrIntervaloJogos ?? undefined,
      petNrDuracaoEmb: rawForm.petNrDuracaoEmb ?? undefined,
      petNrMaxEmbSimultaneos: rawForm.petNrMaxEmbSimultaneos ?? undefined,
      petBlTrocaOrdemConfronto: rawForm.petBlTrocaOrdemConfronto ?? false,
      petTxTipo: rawForm.petTxTipo ?? undefined,
      petNrQtdChe: rawForm.petNrQtdChe ?? undefined,
      petNrQtdInc: rawForm.petNrQtdInc ?? undefined,
      petNrQuantidadeCabecasDeChave:
        rawForm.petNrQuantidadeCabecasDeChave ?? undefined,
      petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias:
        rawForm.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias ?? undefined,
      petBlEmbDireto: rawForm.petBlEmbDireto ?? false,
      petBlEdicaoBloqueada: rawForm.petBlEdicaoBloqueada ?? false,
      petBlPermiteMesmoEstado: rawForm.petBlPermiteMesmoEstado ?? false,
      mocNrId: rawForm.mocNrId ?? undefined,
      inscricaoEtapaForms: this.selectedEntries.map((entry) =>
        StepParameterizationSubscriptionForm.fromParticipant({
          incNrId: entry.insNrId!,
          isCabecaChave: entry.isCabecaChave ?? false,
        }),
      ),
      chavesEmbateForm: this.chaveEmbateFormList || [],
      federacaoEtapaForm: {
        fedNrIds: this.selectedFederationIds,
      },
      rodadaForms: rawForm.rodadaForms.map((rodada, index) => ({
        entNrId: rodada.entNrId ?? undefined,
        entTxMetadado: rodada.entTxMetadado ?? undefined,
        rodTxNome: rodada.rodTxNome ?? '',
        rodTxTipoRodada: rodada.rodTxTipoRodada ?? null,
        rodDtInicio: rodada.rodDtInicio ?? '',
        rodDtFim: rodada.rodDtFim ?? '',
        rodNrOrdemExecucao: rodada.rodNrOrdemExecucao ?? index + 1,
      })),
    });

    if (this.isEditing && this.petNrId) {
      form.entNrId = this.petNrId;
      form.entTxMetadado = MetadataPutEnum.ALTERADO;
    }

    return form;
  }
  onSubmitStepForms(): void {
    this.loadingService.activate();

    if (this.stepParameterizationForm.invalid) {
      this.loadingService.deactivate();
      return;
    }

    const editBlocked = !!this.stepParameterizationForm.get(
      'petBlEdicaoBloqueada',
    )!.value;

    const form = this.buildStepForms();
    form.petBlEmbDireto = this.petBlEmbDireto;
    form.ettNrId = this.ettNrIdSportTemplateSaved;
    form.petBlEdicaoBloqueada = editBlocked;

    //Se estiver editando e o número de chaves for maior que o anterior, reseta a flag para permitir gerar novas chaves.
    if (
      this.isEditing &&
      this.isKeysGenerated &&
      form.petNrQtdChe != null &&
      this.qtdChaves != null &&
      form.petNrQtdChe > this.qtdChaves
    ) {
      (form as any).petBlChavesGeradas = false;
    }

    const save$ = this.isEditing
      ? this.stepParametrizationService.editStepParametrization$(form)
      : this.stepParametrizationService.createStepParametrization$(form);

    const finalizeOk = (value: ICompleteStepParameterizationDto) => {
      this.snackbarService.showSuccess(
        this.isEditing
          ? 'Etapa editada com sucesso!'
          : 'Etapa cadastrada com sucesso!',
      );
      setTimeout(() => {
        if (this.isEditing) {
          this.router.navigate(['parametrizacao-etapa']);
        } else {
          this.isEditing = true;
          this.petNrId = value.petNrId;
          this.loadRodadas(this.petNrId!);
          setTimeout(() => (this.currentStep = 3), 200);
        }
      }, 500);
    };

    save$.subscribe({
      next: (value) => {
        this.loadingService.deactivate();
        finalizeOk(value);
      },
      error: (err) => {
        this.messageErrorResolver.resolveMessage(err);
        this.loadingService.deactivate();
      },
    });
  }

  validateQtdMaxParticipants() {
    let valid = false;
    const currentQtdParticipantsStepParametrization =
      this.selectedEntries.length;
    if (
      currentQtdParticipantsStepParametrization ===
      this.qtdMaxParticipantsStepParametrization
    ) {
      this.snackbarService.showWarn(
        'Quantidade máxima de participantes alcançada.',
      );
      return valid;
    }
    return !valid;
  }
  addParticipants(participant: ListAthleteEnrollmentsDto): void {
    if (!this.validateQtdMaxParticipants()) return;
    this.autoSelectEnabled = false;
    if (this.isOtherStepValue) {
      this.addParticipantsOtherPhase(participant);
      this.selectedEntries.push(participant);
    } else {
      const exists = this.selectedEntries.some(
        (p) => p.insNrId === participant.insNrId,
      );
      if (!exists) this.selectedEntries.push(participant);
      this.participants = this.participants.filter(
        (p) => p.insNrId !== participant.insNrId,
      );
    }
    this.allParticipantsList = this.isOtherStepValue
      ? [...this.participantsOtherPhase, ...this.selectedEntries]
      : [...this.participants, ...this.selectedEntries];
    this.cdr.detectChanges();
  }

  addAllParticipants(): void {
    if (!this.validateQtdMaxParticipants()) return;
    this.autoSelectEnabled = false;
    if (this.isOtherStepValue) {
      this.selectedEntries.push(...this.participantsOtherPhase);
      this.participantsOtherPhase = [];
    } else {
      this.selectedEntries.push(...this.participants);
      this.participants = [];
    }
    this.allParticipantsList = this.isOtherStepValue
      ? [...this.participantsOtherPhase, ...this.selectedEntries]
      : [...this.participants, ...this.selectedEntries];
    this.cdr.detectChanges();
  }
  removeParticipant(participant: ListAthleteEnrollmentsDto): void {
    this.autoSelectEnabled = false;
    if ((participant as any).ineNrId != null) {
      this.removeParticipantOhterPhase(participant);
      return;
    }
    this.selectedEntries = this.selectedEntries.filter(
      (p) => p.insNrId !== participant.insNrId,
    );
    this.participants = [participant, ...this.participants];
    this.allParticipantsList = this.isOtherStepValue
      ? [...this.participantsOtherPhase, ...this.selectedEntries]
      : [...this.participants, ...this.selectedEntries];
    this.cdr.detectChanges();
  }

  removeParticipantOhterPhase(participant: ListAthleteEnrollmentsDto): void {
    this.autoSelectEnabled = false;
    this.selectedEntriesOtherPhase = this.selectedEntriesOtherPhase.filter(
      (p) => p.ineNrId !== (participant as any).ineNrId,
    );
    this.selectedEntries = this.selectedEntries.filter(
      (p) => p.ineNrId !== (participant as any).ineNrId,
    );

    const currentPet = this.isOtherStepForm.get('fase')?.value ?? null;
    const currentChe = this.isOtherStepForm.get('chave')?.value ?? null;
    const currentSearch = (this.enrollmentFilters.getValue().incTxResumo ?? '')
      .toString()
      .toLowerCase();

    const matchesPhase =
      currentPet == null || (participant as any).petNrId === currentPet;
    const matchesKey =
      currentChe == null || (participant as any).cheNrId === currentChe;
    const matchesSearch =
      !currentSearch ||
      (participant.insTxResumo ?? '')
        .toString()
        .toLowerCase()
        .includes(currentSearch);

    if (matchesPhase && matchesKey && matchesSearch) {
      this.participantsOtherPhase = [
        participant,
        ...this.participantsOtherPhase,
      ];
    }

    this.allParticipantsList = [
      ...this.participantsOtherPhase,
      ...this.selectedEntries,
    ];
    this.cdr.detectChanges();
  }

  addParticipantsOtherPhase(participant: ListAthleteEnrollmentsDto): void {
    this.autoSelectEnabled = false;
    const exists = this.selectedEntriesOtherPhase.some(
      (p) => p.ineNrId === participant.ineNrId,
    );
    if (!exists) this.selectedEntriesOtherPhase.push(participant);
    this.participantsOtherPhase = this.participantsOtherPhase.filter(
      (p) => p.ineNrId !== participant.ineNrId,
    );
    this.allParticipantsList = [
      ...this.participantsOtherPhase,
      ...this.selectedEntries,
    ];
    this.cdr.detectChanges();
  }

  cancelForm() {
    this.router.navigate(['parametrizacao-etapa']).then();
  }
  iconItemDisableFn(item: any) {
    return item.isCabecaChave || item.ineBlCabecaChave;
  }
  statusItemFn = (item: any) => {
    if (this.isOtherStepValue) {
      return item.claBlClassificado ? 'Classificado' : 'Não Classificado';
    }
    return '';
  };
  statusItemClassFn = (item: any) => {
    let classItem: string =
      'p-[5px] mr-4  items-center justify-center rounded-[12px] text-xs font-semibold';
    if (this.isOtherStepValue) {
      if (item.claBlClassificado) {
        classItem = classItem.concat(' text-[#31920F] bg-[#D0F8C2]');
      } else {
        classItem = classItem.concat(' text-red-700 bg-red-400');
      }
      return classItem;
    }
    return '';
  };

  showError(key: string) {
    return this.handlerErrorMessage.showErrorMessageForKey(
      this.stepParameterizationForm,
      key,
    );
  }

  onEnter(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === 'Enter') keyboardEvent.preventDefault();
  }
}
